.page {
  max-width: 880px;
  margin: 0 auto;
  padding: 32px var(--space-5) 60px;
  background: #fff;
  color: var(--color-ink);
}

.crumb {
  display: inline-block;
  color: var(--color-ink-soft);
  font-size: 0.78rem;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  margin-bottom: 18px;
  text-decoration: none;
}

.eyebrow {
  display: inline-block;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: var(--color-ember-dark);
}

.head { margin-bottom: 32px; }

.title {
  font-family: var(--font-display);
  font-size: var(--fs-3xl);
  font-weight: 800;
  letter-spacing: -0.01em;
  line-height: 1.05;
  margin: 8px 0 16px;
}

.summary {
  margin: 0;
  font-size: 1.15rem;
  line-height: 1.55;
  color: var(--color-ink-soft);
  max-width: 60ch;
}

.body {
  display: flex;
  flex-direction: column;
  gap: 28px;
  margin-top: 12px;
}

.step {
  display: grid;
  grid-template-columns: 64px 1fr;
  gap: 20px;
  padding: 24px 0;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}

.step:first-of-type { border-top: 2px solid var(--color-ink); }

.stepNum {
  font-family: var(--font-display);
  font-size: 2rem;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: var(--color-ember);
  line-height: 1;
}

.stepBody { display: flex; flex-direction: column; gap: 10px; }

.stepTitle {
  font-family: var(--font-display);
  font-size: 1.4rem;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 1.2;
  margin: 0;
}

.stepText {
  margin: 0;
  font-size: 1.02rem;
  line-height: 1.6;
  color: var(--color-ink);
  max-width: 60ch;
}

.callout {
  background: rgba(243, 154, 46, 0.1);
  border-left: 3px solid var(--color-ember);
  padding: 10px 14px;
  font-size: 0.95rem;
  color: var(--color-ink);
  border-radius: 0 6px 6px 0;
}

.sizeChart {
  border-collapse: collapse;
  width: 100%;
  max-width: 460px;
  margin-top: 8px;
}

.sizeChart th {
  text-align: left;
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  color: var(--color-ink-soft);
  font-weight: 700;
  padding: 10px 12px;
  border-bottom: 1px solid var(--color-ink);
}

.sizeChart td {
  padding: 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  font-size: 0.95rem;
}

.tips {
  margin-top: 16px;
  padding: 22px 24px;
  background: var(--color-bone);
  border-radius: 10px;
}

.tipsTitle {
  font-family: var(--font-display);
  font-size: 1.1rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  margin: 0 0 12px;
}

.tips ul {
  margin: 0;
  padding-left: 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.tips li { line-height: 1.55; }

/* Index */
.indexHead { margin-bottom: 24px; }

.indexTitle {
  font-family: var(--font-display);
  font-size: var(--fs-3xl);
  font-weight: 800;
  letter-spacing: -0.01em;
  margin: 4px 0 0;
}

.cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 18px;
}

.card {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 22px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  text-decoration: none;
  color: var(--color-ink);
  transition: border-color 140ms ease, box-shadow 140ms ease;
}

.card:hover {
  border-color: var(--color-ember);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
}

.cardEyebrow {
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: var(--color-ember-dark);
}

.cardTitle {
  margin: 0;
  font-family: var(--font-display);
  font-size: 1.4rem;
  font-weight: 800;
  letter-spacing: -0.005em;
}

.cardSummary {
  margin: 0;
  font-size: 0.95rem;
  color: var(--color-ink-soft);
  line-height: 1.5;
}

.cardCta {
  margin-top: auto;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--color-ember-dark);
}

.link { color: var(--color-ember-dark); }

@media (max-width: 768px) {
  .step { grid-template-columns: 44px 1fr; gap: 14px; }
  .stepNum { font-size: var(--fs-xl); }
}
